import CardTemplate from '@src/components/Template/Card';
import { fetchDonations, useDonations } from '@src/hooks/useCommunitys';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import InfiniteScroll from 'react-infinite-scroller';
import { IContent } from '@src/interfaces/community';
import PageTemplate from '@src/components/Template/Page';
import Skeleton from '@src/components/LoadingSkeleton';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import keywordAtom from '@src/recoils/atom/keyword';
import { aboSort, bloodProductSort, sort } from '@src/utils/community';
import filterAtom from '@src/recoils/atom/filter';
import Meta from '@src/components/Meta';
import { metaInfo } from '@src/data/meta';
import NotFound from '@src/components/Molecules/Card/NotFound';

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = new QueryClient();
  await queryClient.prefetchInfiniteQuery(['donation-page'], fetchDonations);
  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};

const CommunityPage = () => {
  const { title, description, ogImage } = metaInfo.donation;
  const keyword = useRecoilValue(keywordAtom);
  const filterList = useRecoilValue(filterAtom);
  const filterLabel = (type: string) => {
    const want = filterList.filter((e) => e.type === type);
    return want[0].label;
  };
  const { communitys, hasNextPage, fetchNextPage, isLoading } = useDonations(
    keyword,
    aboSort(filterLabel('abo')),
    bloodProductSort(filterLabel('bloodProduct')),
    sort(filterLabel('sortBy'))
  );
  useEffect(() => {
    const ScrollY = sessionStorage.getItem('community_scroll');
    if (Number(ScrollY) !== 0) window.scrollTo(0, Number(ScrollY));
  }, []);
  console.log(communitys);

  return (
    <>
      <Meta title={title} description={description} ogImage={ogImage} />
      <PageTemplate
        isSide={true}
        href={'/community/donation'}
        mainText={'헌혈요청'}
        isLoading={isLoading}
      >
        {/* 게시물 존재할때 */}
        {isLoading &&
          [0, 1, 2, 3, 4].map((e) => <Skeleton.LoadingSkeletonCard />)}
        {communitys?.pages[0].data.totalElements !== 0 && !isLoading && (
          <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage as any}>
            {communitys?.pages.map((page) =>
              page.data.content.map((community: IContent, i: number) => (
                <CardTemplate
                  key={community.uuid}
                  image={community.images.length !== 0}
                  community={community}
                />
              ))
            )}
          </InfiniteScroll>
        )}
        {communitys?.pages[0].data.totalElements === 0 && (
          <NotFound
            isNotFound={communitys?.pages[0].data.totalElements === 0}
          />
        )}
      </PageTemplate>
    </>
  );
};

export default CommunityPage;
